var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import linker from '../linker';
var BackToParent = (function (_super) {
    __extends(BackToParent, _super);
    function BackToParent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.text = '';
        _this.url = '#';
        _this.onBreadcrumbLoadedDelegate = _this.onBreadcrumbLoaded.bind(_this);
        return _this;
    }
    BackToParent.prototype.mounted = function () {
        this.load();
        window.document.addEventListener('rubBreadcrumbLoaded', this.onBreadcrumbLoadedDelegate);
    };
    BackToParent.prototype.beforeDestroy = function () {
        window.document.removeEventListener('rubBreadcrumbLoaded', this.onBreadcrumbLoadedDelegate);
    };
    BackToParent.prototype.onBreadcrumbLoaded = function (evnt) {
        if (evnt && evnt.detail && evnt.detail.parentTitle && evnt.detail.parentUrl) {
            this.text = "\u00AB Zur\u00FCck zu " + evnt.detail.parentTitle;
            this.url = evnt.detail.parentUrl;
        }
    };
    BackToParent.prototype.load = function () {
        if (this.$el && this.$el.previousElementSibling) {
            var expandedNodes = this.$el.previousElementSibling.querySelectorAll("a.riNavExpanded:not(.riNavSelected)");
            if (expandedNodes.length == 0) {
                this.text = "« Zurück zur Startseite";
                this.url = _spPageContextInfo.siteServerRelativeUrl;
            }
            else {
                var parentNode = expandedNodes.item(expandedNodes.length - 1);
                this.text = "\u00AB Zur\u00FCck zu " + parentNode.textContent;
                this.url = parentNode.href;
            }
        }
    };
    BackToParent = __decorate([
        Component({})
    ], BackToParent);
    return BackToParent;
}(Vue));
export default BackToParent;
linker.register('backToParent', BackToParent);
